"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeHlsPlayer = void 0;
const adapter_1 = require("../../api/adapter");
const feature_1 = require("../../api/player/features/feature");
const errors_deprecated_1 = require("../errors-deprecated");
const browser_1 = require("../utils/browser-support/browser");
const core_1 = require("./core");
class NativeHlsPlayer extends core_1.CorePlayer {
    constructor(ctx, provider, options) {
        super(ctx, provider, options);
        this.srcReset = false;
        // temporary variable remove when HC is merged
        this.manifestJson = null;
        this.on("currentQuality", this.handleCurrentQuality);
        this.addInnerDisposer(() => {
            this.off("currentQuality", this.handleCurrentQuality);
        });
    }
    handleCurrentQuality() {
        this.srcReset = false;
        this.handleSource(this.manifestJson);
    }
    static async isSupported(logger) {
        return (0, browser_1.supportsNativeHls)(logger);
    }
    async isSupported() {
        return NativeHlsPlayer.isSupported();
    }
    static get format() {
        return "mp4-hls";
    }
    get format() {
        return NativeHlsPlayer.format;
    }
    async handleSource(manifest) {
        var _a, _b, _c, _d, _e;
        if (this.suspended) {
            return;
        }
        this.ctx.logger.debug("native-hls: handleSource()");
        const format = manifest === null || manifest === void 0 ? void 0 : manifest.formats["mp4-hls"];
        if (format == null) {
            this.emitErrorDeprecated(new errors_deprecated_1.DriverNotSupportedError("manifest doesn't contains 'mp4-hls' format", {
                manifest,
                loader: this.provider,
            }));
            return;
        }
        if (manifest != null) {
            this.manifestJson = manifest;
        }
        if (((_b = (_a = this.currentQuality) === null || _a === void 0 ? void 0 : _a.layer) === null || _b === void 0 ? void 0 : _b.id) != null && this.currentQuality.layer.id !== "") {
            this.source = this.currentQuality.layer.id.toString();
        }
        else if (((_c = format === null || format === void 0 ? void 0 : format.substitute) === null || _c === void 0 ? void 0 : _c.location) != null) {
            this.source = format.substitute.location;
        }
        else {
            this.source = format.manifest;
        }
        // !this.hostEl.src won't work here because browser default the src to the window.location. Why? IDK.
        if (adapter_1.device.isImplements(adapter_1.Feature.URL_LOCATION) && this.elementSupervisor != null) {
            if (this.elementSupervisor.sourceKind !== "src") {
                this.srcReset = true;
            }
        }
        if ((this.elementSupervisor != null && this.elementSupervisor.sourceKind !== "src") ||
            (this.elementSupervisor != null && !this.srcReset)) {
            const currentTime = this.elementSupervisor.currentTime;
            this.srcReset = true;
            (_d = this.elementSupervisor) === null || _d === void 0 ? void 0 : _d.updateSrc(this.source);
            // keep current time for recorded videos
            if (((_e = this.manifestJson) === null || _e === void 0 ? void 0 : _e.type) === "recorded" && currentTime > 0) {
                this.elementSupervisor.currentTime = currentTime;
            }
            if (!this.internalPaused || (this.options.autoPlay && !this.internalPaused)) {
                try {
                    await this.play(true);
                }
                catch (err) {
                    const inner = err instanceof Error ? err : null;
                    this.emitErrorDeprecated(new errors_deprecated_1.PlayingIssueError("autoplay call failed after handleSource()", {
                        inner,
                        player: this,
                    }));
                }
            }
        }
    }
    async attachTo(el) {
        await super.attachTo(el);
        if (this.options.autoPlay) {
            try {
                await this.play(true);
            }
            catch (err) {
                const inner = err instanceof Error ? err : null;
                this.emitErrorDeprecated(new errors_deprecated_1.PlayingIssueError("autoplay call failed after attachTo()", {
                    inner,
                    player: this,
                }));
            }
        }
    }
    get implementedFeatures() {
        return [feature_1.Feature.BITRATE_SWITCHING, feature_1.Feature.MUTED_AUTOPLAY];
    }
}
exports.NativeHlsPlayer = NativeHlsPlayer;
NativeHlsPlayer.displayName = "NativeHlsPlayer";
//# sourceMappingURL=native-hls.js.map